export default __webpack_public_path__ + "static/media/IconDiscover.4c8f1a85.png";